import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

interface ConfirmDeleteDialogProps {
  open: boolean;
  title: string;
  itemName: string;
  warningText?: string;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmDeleteDialog = ({
  open,
  title,
  itemName,
  warningText,
  onCancel,
  onConfirm,
  loading = false,
}: ConfirmDeleteDialogProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="confirm-delete-title"
    aria-describedby="confirm-delete-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle id="confirm-delete-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="confirm-delete-description">
        Are you sure you want to delete <strong>{itemName}</strong>?
      </DialogContentText>
      {warningText && (
        <Typography variant="body2" color="warning.main" sx={{ mt: 1.5 }}>
          {warningText}
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="inherit" disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
